import { getActivePinia, storeToRefs, } from 'pinia'
import { LOADED, usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { computed, } from 'vue'
import { useHelpListStore, } from '@/assets/js/src/modules/help/_pinia/helpList'
import { mapUserOptionByPath, } from '@/assets/js/src/modules/user/_pinia/mapUserOptionByPath'

export function useHelpListApi () {
    let helpListStore = useHelpListStore(getActivePinia())

    const { helpItems,helpCategories, } = storeToRefs(helpListStore)
    const { messagesLoaded, asyncStatus, } = usePrefetchData({
        actions: [
            {
                item: helpItems,
                action: helpListStore.getHelpItems,
            },
        ],
        loadAsyncMessages: [ 'help', 'common', ],
    })

    const asyncStatusLoaded = computed(()=>asyncStatus.value === LOADED)

    const gridView = computed(mapUserOptionByPath('help/gridView'))

    return {
        messagesLoaded,
        helpItems,
        helpCategories,
        asyncStatusLoaded,
        gridView,
    }
}
